import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

const CircularIcon = ({ icon: Icon, color = 'neutral', marginBottom = 0, centered = false }) => {
    const circleClassName = classNames(
        'w-20 h-20 min-w-[80px] flex items-center justify-center rounded-full',
        {
            'bg-neutral-200': color === 'neutral',
            'bg-lime-500': color === 'lime',
            'bg-purple-100': color === 'purple',
        },
        centered && 'mx-auto'
    );

    const iconColor = {
        neutral: '#5E6470',
        lime: '#FFFFFF',
        purple: '#754DCF',
    }[color];

    return (
        <div className={circleClassName} style={{ marginBottom }}>
            <Icon width={32} height={32} color={iconColor} />
        </div>
    );
};

CircularIcon.propTypes = {
    icon: PropTypes.elementType.isRequired,
    color: PropTypes.oneOf(['neutral', 'lime', 'purple']),
    marginBottom: PropTypes.number,
    centered: PropTypes.bool,
};

export default CircularIcon;
